// extracted by mini-css-extract-plugin
export default {"comingButtonBackground":"ComingButton_comingButtonBackground__1OWaT","buttonText":"ComingButton_buttonText__Y4UJO"};